export const namespaces = ['common', 'navigation', 'landing', 'dashboard', 'records'] as const;

// Each code needs a matching public/locales/<code>/ folder with every namespace file.
// Labels are in the language itself so users can find theirs.
export const supportedLanguages = [
  { code: 'en', label: 'English' },
  { code: 'am', label: 'አማርኛ' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'ko', label: '한국어' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'zh', label: '中文' },
] as const;

export type LanguageCode = (typeof supportedLanguages)[number]['code'];

export const defaultLanguage: LanguageCode = 'en';
